import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../../constants/typography';
import {FilterItem} from './FilterItem';
import {GenericFilterItemGroup} from './types';

export type OnDataClickType = (itemId: string, itemSlug?: string) => void;

export const FilterGroup: React.FC<{
  activeIds: Array<string>;
  onItemClick?: OnDataClickType;
  dataGroup: GenericFilterItemGroup;
  isFirstGroup?: boolean;
  dataTestId?: string;
  enableFilterFlyout?: boolean;
  shouldUppercaseItems?: boolean;
}> = ({
  dataGroup: {items, groupLabel},
  activeIds,
  onItemClick,
  isFirstGroup,
  dataTestId,
  enableFilterFlyout = true,
  shouldUppercaseItems,
}) => {
  return (
    <StyledFilterGroup
      first={isFirstGroup}
      key={`filter-flyout-group-${groupLabel}`}
      data-testid={dataTestId}
    >
      <FilterGroupTitle $smallerTitle={enableFilterFlyout}>
        {groupLabel}
      </FilterGroupTitle>

      {items.map(item => (
        <FilterItem
          isActive={activeIds.includes(item.id)}
          id={item.id}
          slug={item.slug}
          label={item.label}
          count={item.count}
          key={item.id}
          onItemClick={onItemClick}
          enableFilterFlyout={enableFilterFlyout}
          shouldUppercaseLabel={shouldUppercaseItems}
        />
      ))}
    </StyledFilterGroup>
  );
};

const FilterGroupTitle = styled.h5<{$smallerTitle: boolean}>`
  color: ${COLORS.Black};
  font-size: ${props =>
    props.$smallerTitle ? FONT_SIZES.px18 : FONT_SIZES.px24};
  font-weight: ${FONT_WEIGHTS.bold};
  margin: 0 0 1rem ${props => (props.$smallerTitle ? '0' : '1rem')};
`;

const StyledFilterGroup = styled.div<{first?: boolean}>`
  padding: 1.125rem 0 1rem 0;
  border-top: ${({first}) => (first ? 'none' : `1px solid ${COLORS.Grey3}`)};
  background-color: ${COLORS.White};
  margin-bottom: 0;
`;
